import React from 'react';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { useCompensationSetting } from '../../../components/use-compensation-setting';
import { ScheduledPayments } from './scheduled-payments';
import { OneTimePayments } from './one-time-payments';

export function CompensationHistory() {

	const settings = useCompensationSetting();

	return (
		<>
			<PageHeader headerText={settings.compensationHistoryTitle} description={settings.compHistoryDescription} />
			
			<ScheduledPayments />
			<OneTimePayments />
		</>
	);
}